/*eslint new-cap:0 */
import ko from 'knockout';
import _ from 'underscore';
import Backbone from 'backbone';
import templateDefault from '@bingads-webui-campaign-legacy/advanced-settings/template/ad-distribution.pug';
import templateSpaSpb from '@bingads-webui-campaign-legacy/advanced-settings/template/ad-distribution-spa-spb.pug';
import templateWinStoreAdsCpa from '@bingads-webui-campaign-legacy/advanced-settings/template/ad-distribution-win-store-ads-cpa.pug';
import ViewModel from '@bingads-webui-campaign-legacy/advanced-settings/viewmodel/ad-distribution';
import pageContext from '@bingads-webui-static-legacy/page-context';
import config from '@bingads-webui-component-legacy/config/index';
import { appendLearnMoreLink } from '@bingads-webui-component-legacy/help/index';
import * as languageBundle from '@bingads-webui-campaign-legacy/location-targets/util/languageBundle';
import * as LocationTargetTypes from '@bingads-webui-campaign-legacy/location-targets/util/locationTargetTypes';
import { syndEnum } from '@bingads-webui-campaign-react/constants';
import jsdata from '@bingads-webui-component-legacy/js-data-campaign/index';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');

/*source: localizedsetting.config (UI\config\LocalizedSettings.config), markets which have syndication enabled (isSyndicationOptEnabled="true")
*/
const marketsSyndicationOptEnabled = [{
  Language: 'French',
  Market: 'CA',
}, {
  Language: 'French',
  Market: 'FR',
}, {
  Language: 'English',
  Market: 'CA',
}, {
  Language: 'English',
  Market: 'GB',
}, {
  Language: 'English',
  Market: 'IE',
}, {
  Language: 'English',
  Market: 'US',
}, {
  Language: 'English',
  Market: 'AU',
}, {
  Language: 'German',
  Market: 'DE',
}, {
  Language: 'Norwegian',
  Market: 'NO',
}].concat(_.result(config.get('Permissions'), 'IsSyndOptOutToEuropeanAndIndiaEnabled') ?
  [{
    Language: 'Italian',
    Market: 'IT', // Italy
  }, {
    Language: 'Spanish',
    Market: 'ES', // Spain
  }, {
    Language: 'Dutch',
    Market: 'NL', // Netherlands
  }, {
    Language: 'Swedish',
    Market: 'SE', // Sweden
  }, {
    Language: 'Danish',
    Market: 'DK', // Denmark
  }, {
    Language: 'German',
    Market: 'AT', // Austria
  }, {
    Language: 'France',
    Market: 'BE', // Belgium
  }, {
    Language: 'Finnish',
    Market: 'FI', // Finland
  }, {
    Language: 'English',
    Market: 'IN', // India
  }] :
  []);

const isSponsoredPilotEnabled = pageContext && pageContext.Permissions && pageContext.Permissions.IsSPAv2Enabled;
const isSponsoredPromotionsByBrandsEnabled = pageContext && pageContext.Permissions && pageContext.Permissions.dynamic && pageContext.Permissions.dynamic.SponsoredPromotionsByBrands;
const isSpaViaNewMmcApiEnabled = pageContext && pageContext.Permissions && pageContext.Permissions.dynamic && pageContext.Permissions.dynamic.SpaViaNewMmcApi;
const isWindowsStoreAdsManualCPAEnabled = pageContext && pageContext.Permissions && pageContext.Permissions.dynamic && pageContext.Permissions.dynamic.WindowsStoreAdsManualCPA;

/*For multiple campaign, it will first try to get it from adgorup langauge
  When adgroup language is null, it will then go back to campaign languages
*/
function syndLanguageSupported(language, languages) {
  const syndShownForAllLanguages =  Boolean(_.result(config.get('Permissions'), 'IsSyndShownForAllLanguages'));

  if (syndShownForAllLanguages) {
    return true;
  }

  const languageSets = language ? [language] : languages || [];

  return _.isEmpty(languageSets) || _.contains(languageSets, 'All') ?
    true :
    _.any(languageSets, (lang) => {
      return _.contains(_.pluck(marketsSyndicationOptEnabled, 'Language'), lang);
    });
}

export default class View extends Backbone.View {
  initialize({
    AdDistribution = syndEnum.BingYahooAndSearchPartners,
    Medium = '',
    Language = '',
    Languages = [],
    campaignType = 'search',
    campaignSubType = null,
    level = 'campaign',
    activityLogger,
    onChange,
    isSPBCampaign = false,
    isMSStoreAdsGAWorkflow,
  } = {}) {
    this.viewModel = new ViewModel({
      AdDistribution,
      Medium,
      campaignType,
      campaignSubType,
      showSynd: syndLanguageSupported(Language, Languages),
      isSPBCampaign,
      isMSStoreAdsGAWorkflow,
    });
    this.isMSStoreAdsGAWorkflow = isMSStoreAdsGAWorkflow;

    this.level = level;
    this.languages = Languages;
    this.campaignType = campaignType;

    this.isSponsoredCampaign = (isSponsoredPilotEnabled && config.get('CampaignObjective') === 'SponsoredShoppingCampaign') || campaignSubType === 'ShoppingSponsoredProductAd';
    this.isMicrosoftStoreAd = isMSStoreAdsGAWorkflow;

    this.viewModel.Medium.searchSelected.subscribe((value) => {
      this.trigger('search:change', value);
    });

    this.viewModel.AdDistribution.subscribe((value) => {
      if (activityLogger) {
        activityLogger.signal('ad distribution changed', 'ad distribution');
      }

      if (_.isFunction(onChange)) {
        onChange(value);
      }
    });

    this.viewModel.isSPBCampaign.subscribe(this.onSponsoredCampaignTypeChange, this);
  }

  render() {
    let template;

    const isDeprecateSyndicationSearchOnly = Boolean(_.get(config.get('Permissions'), ['dynamic', 'DeprecateSyndicationSearchOnly']));
    const isSyndicationSearchOnlyWhitelist = Boolean(_.get(config.get('Permissions'), ['dynamic', 'SyndicationSearchOnlyWhitelist']));
    const option = this.viewModel.AdDistribution();
    const isSyndicationSearchOnlyChecked = option === syndEnum.SearchPartnersOnly;

    const coreTemplateParams = {
      appendLearnMoreLink,
      i18n,
      nativeAdsAllowed: Boolean(_.result(config.get('Permissions'), 'IsNativeAdsAllowed')),
      isMSStoreAdsGAWorkflow: this.isMSStoreAdsGAWorkflow,
      showSyndicationSearchOnly: !isDeprecateSyndicationSearchOnly || isSyndicationSearchOnlyWhitelist || isSyndicationSearchOnlyChecked,
    };

    if (this.isMSStoreAdsGAWorkflow || (this.isSponsoredCampaign && this.isMicrosoftStoreAd && isWindowsStoreAdsManualCPAEnabled)) {
      // Windows store ads with manual CPA enabled
      template = templateWinStoreAdsCpa(coreTemplateParams);
    } else if (!this.isMicrosoftStoreAd && this.isSponsoredCampaign && (isSponsoredPromotionsByBrandsEnabled || isSpaViaNewMmcApiEnabled)) {
      // SPA/SPB with new MMC API
      template = templateSpaSpb(coreTemplateParams);
    } else {
      // All other campaigns (including old WindowsStoreAds and old SPA path)
      template = templateDefault(_.extend(coreTemplateParams, {
        isSponsoredCampaign: this.isSponsoredCampaign,
        isMicrosoftStoreAd: this.isMicrosoftStoreAd,
        adDistribution: this.viewModel.AdDistribution(),
        showSyndicationSearchOnly: isSyndicationSearchOnlyChecked || (isSyndicationSearchOnlyWhitelist && _.includes(['search', 'shopping', 'hotel'], this.campaignType)),
      }));
    }

    this.$el.html(template);

    ko.applyBindings(this.viewModel, this.el);

    return this;
  }

  onSponsoredCampaignTypeChange(isSPBCampaign) {
    this.setInHouseStatus(!isSPBCampaign);
  }

  setIsSponsoredCampaignCashbackEnabled(isEnabled) {
    this.viewModel.isSPBCampaign(isEnabled);
  }

  getTranslatedOption() {
    const option = this.viewModel.AdDistribution();

    switch (option) {
    case syndEnum.BingYahooOnly:
      return i18n.get('SyndicationType_MicrosoftSitesAndPartnerNetwork_Endor');
    case syndEnum.SearchPartnersOnly:
      return i18n.get('SyndicationType_OnlySyndicatedPartnerNetwork_Endor');
    case syndEnum.BingYahooAndSearchPartners:
    default:
      return i18n.get('SyndicationType_EntireMicrosoftAdvertisingNetwork_Endor');
    }
  }

  getValues() {
    return this.viewModel.toObject();
  }

  validate() {
    return this.viewModel.validate();
  }

  toObject() {
    let params = this.viewModel.toObject();

    if (!this.viewModel.Medium.searchSelected()) {
      params = _.omit(params, 'AdDistribution');
    }

    return params;
  }

  /*called in new campaign creation step4:
    1) update syndication status
    2) update contentNetwork checkbox status
    language will be array in campaign multiple langauge (pilot feature)
  */
  update(language) {
    const isMultipleLanguage = _.isArray(language);
    let criterions = jsdata.Intermediate.getAll('CampaignCriterion');
    let adgroupLanguage = isMultipleLanguage ? null : language;

    if (isMultipleLanguage) {
      this.languages = language;
    }

    this.viewModel.showSynd(syndLanguageSupported(adgroupLanguage, this.languages));
    this.isSyndOptionAllowed(adgroupLanguage, criterions);
  }

  isLocationTargetingsAllowed(language, criterions) {
    //First get the included location targetings
    const includedTargets = _.filter(criterions, (criterion) => {
      return criterion.SelectionStatus === LocationTargetTypes.Included;
    });
    const locationPublisherCountryMap = languageBundle.getLanguageLocationPublisherCountryData(language ? language : this.languages);

    if (_.isEmpty(includedTargets) || !locationPublisherCountryMap) {
      //target everywhere or locationPublisherCountryMap is null, then only use language to check
      return true;
    }

    let langmarketSelection = [];
    const locationTargets = _.filter(includedTargets, (target) => {
      return target.Criterion.Type === 'Location';
    });

    if (_.isEmpty(locationTargets)) {
      //If all the targetings are radius targeting, use the non-supported publisher countries
      langmarketSelection = locationPublisherCountryMap.NoSupported;
    } else {
      _.each(locationTargets, (location) => {
        const criterion = location.Criterion.LocationCriterion;
        const publisherCountries = locationPublisherCountryMap[criterion.CountryCode] || locationPublisherCountryMap.NoSupported;

        langmarketSelection = langmarketSelection.concat(publisherCountries);
      });
    }

    const supportedCountries = _.pluck(_.filter(marketsSyndicationOptEnabled, (pair) => {
      return language ? pair.Language === language :
        (_.contains(this.languages, pair.Language) || _.contains(this.languages, 'All')); //eslint-disable-line
    }), 'Market');

    return _.some(_.intersection(supportedCountries, langmarketSelection));
  }

  isSyndOptionAllowed(language, criterions) {
    const syndShownForAllLanguages =  Boolean(_.result(config.get('Permissions'), 'IsSyndShownForAllLanguages'));

    if (syndShownForAllLanguages) {
      this.viewModel.showSynd(true);
      this.viewModel.syndAllowed(true);
      return;
    }

    let isSyndOptionEnabled = syndLanguageSupported(language, this.languages);

    this.viewModel.showSynd(isSyndOptionEnabled);

    //first check language, if language supports, then check location targetings user selected
    isSyndOptionEnabled = isSyndOptionEnabled && this.isLocationTargetingsAllowed(language, criterions);

    this.viewModel.syndAllowed(isSyndOptionEnabled);

    if (!isSyndOptionEnabled) {
      this.viewModel.AdDistribution(syndEnum.BingYahooAndSearchPartners);
    }
  }

  // in BSC adgroup creation page: Will be visible when: 1) it is co-op bsc campaign 2) bid value option 3) In In-House pilot
  setInHouseStatus(isVisible) {
    this.viewModel.showInHouse(isVisible);

    if (!isVisible && this.viewModel.AdDistribution() === syndEnum.InHousePromotion) {
      this.viewModel.AdDistribution(syndEnum.BingYahooAndSearchPartners);
    }
  }
}
